import SLSUsuarioRepresentanteClient from '@/api/SistemaDKP/sls-usuariorepresentante.client';
import { ErrorMessage } from '@/libs/Error';
import Store from '@/store';

export default class SLSUsuarioRepresentanteService {
  constructor() {
    this.client = new SLSUsuarioRepresentanteClient();
    this.error = new ErrorMessage();
    this.store = Store;
  }

  async index(queries) {
    try {
      const { data } = await this.client.index(queries);
      console.log('data', data);
      this.store.commit('SLSUsuarioRepresentante/setUsuariosRepresentantes', data);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar os items');
    }
  }

  async create(data) {
    try {
      const { data: response } = await this.client.store(data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao criar Usuario Representante');
    }
  }

  async findOneUsuario(id) {
    try {
      const { data } = await this.client.findOneUsuario(id);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao buscar Usuario Representante');
    }
  }

  async findOneRepresentante(id) {
    try {
      const { data: response } = await this.client.findOneRepresentante(id, data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao atualizar Usuario Representante');
    }
  }

  async destroy(usuarioid, representanteid) {
    try {
      const { data } = await this.client.destroy(usuarioid, representanteid);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao deletar Usuario Representante');
    }
  }

  async listarRepresentantesNaoSelecionados(queries = this.store.getters['SLSUsuarioRepresentante/getRepresentantesNaoSelecionados']) {
    try {
      const { data: { data, ...pagination } } = await this.client.listarRepresentantesNaoSelecionados(queries);
      this.store.commit('SLSUsuarioRepresentante/setRepresentantesNaoSelecionados', data);
      this.store.commit('SLSUsuarioRepresentante/setFiltersNaoSelecioando', {
        ...pagination,
      });
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar os items');
    }
  }

  async listarRepresentantesSelecionados(queries = this.store.getters['SLSUsuarioRepresentante/getRepresentantesSelecionados']) {
    try {
      const { data: { data, ...pagination } } = await this.client.listarRepresentantesSelecionados(queries);
      this.store.commit('SLSUsuarioRepresentante/setRepresentantesSelecionados', data);
      this.store.commit('SLSUsuarioRepresentante/setFiltersSelecionados', pagination);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar os items');
    }
  }

  async removerTodosRepresentantes(usuarioId) {
    try {
      const { data } = await this.client.removerTodosRepresentantes(usuarioId);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao deletar Usuario Representante');
    }
  }

  async removerSelecionadpRepresentanteSelecionado(dataRemover) {
    try {
      const { data } = await this.client.removerSelecionadpRepresentanteSelecionado(dataRemover);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao deletar Usuario Representante');
    }
  }

  async adicionarTodosRepresentantes(usuarioId) {
    try {
      const { data } = await this.client.adicionarTodosRepresentantes(usuarioId);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao deletar Usuario Representante');
    }
  }

  async adicionarSelecionadoRepresentanteNaoSelecionado(data) {
    try {
      const { data: response } = await this.client.adicionarSelecionadoRepresentanteNaoSelecionado(data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao deletar Usuario Representante');
    }
  }
}
